import type { ReactNode } from "react";

import { cn } from "@/shared/lib";

// Вид варианта: не выбран, выбран, после ответа — верный, «почти» (годится, но верный
// лучше), ошибочный выбор, пропущенный верный (несколько верных) или в стороне.
export type OptionState = "idle" | "picked" | "right" | "close" | "wrong" | "missed" | "dim";

const STATE_CLASSES: Record<OptionState, string> = {
  idle: cn("border-border bg-surface hover:border-border-strong"),
  picked: cn("border-accent bg-sidebar-active"),
  right: cn("border-good bg-good/15"),
  close: cn("border-warn bg-warn/15"),
  wrong: cn("border-bad bg-bad/15"),
  missed: cn("border-dashed border-good bg-surface"),
  dim: cn("border-sidebar-active bg-surface opacity-60"),
};

type OptionButtonProps = {
  state: OptionState;
  pressed: boolean;
  // После ответа варианты не нажимаются, но остаются в порядке табуляции.
  locked: boolean;
  onClick: () => void;
  label?: string;
  className?: string;
  children: ReactNode;
};

// Карточка варианта ответа: кнопка-переключатель (`aria-pressed`).
export const OptionButton = ({
  state,
  pressed,
  locked,
  onClick,
  label,
  className,
  children,
}: OptionButtonProps) => (
  <button
    type="button"
    aria-pressed={pressed}
    aria-disabled={locked}
    aria-label={label}
    onClick={locked ? undefined : onClick}
    className={cn(
      "flex min-h-18 items-center gap-3 rounded-[10px] border-2 px-3.5 py-3 text-left text-foreground transition-colors focus-visible:ring-2 focus-visible:ring-accent/60 focus-visible:outline-none",
      STATE_CLASSES[state],
      locked && "cursor-default",
      className,
    )}
  >
    {children}
  </button>
);
